import React from 'react'
import './styles.scss'

const WarningMessage = ({ text = '' }) => {
  return (
    <div className='warning-message'>
      <div className='warning-message-container'>
        <img src='img/icons/icon-warning.svg' alt='warning' />
        <span className='warning-message-container__text text-ellipsis'>{text}</span>
      </div>
    </div>
  )
}

export default WarningMessage